export enum ComponentState {
    INIT,
    RENDERING,
    RENDERED,
    ERROR
}
